import { RiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<RiskLevel> = new Map([
  [
    Gender.unknown,
    new Map([
      [RiskLevel.Low, [{ lower: 0, upper: 1.7 }]],
      [RiskLevel.Medium, [{ lower: 1.7, upper: 2.3 }]],
      [RiskLevel.High, [{ lower: 2.3, upper: 20 }]],
    ]),
  ],
]);

export default referenceRange;
